export const FIELDS = {

  ID: 'id',
  STATUS_ID: 'statusId',
  SERVICE_ORDER_ID: 'serviceOrderId',
  PURCHASE_ORDER_LINE_ID: 'purchaseOrderLineId',
  INVENTORY_ID: 'inventoryId',
  QUANTITY: 'quantity',
  TOTAL: 'total',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  SALES_ORDER_ID: 'salesOrderId',
  SALES_ORDER_LINE_ID: 'salesOrderLineId',
  STATUS_NAME: 'statusName',
  TEST_HOUSE_ID: 'testHouseId',
  TEST_HOUSE_NAME: 'testHouseName',
  TEST_HOUSE_CONTACT_ID: 'testHouseContactId',
  TEST_HOUSE_CONTACT_NAME: 'testHouseContactName',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  CUSTOMER_ID: 'customerId',
  CUSTOMER_NAME: 'customerName',
  PODATE: 'poDate',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  VENDOR_PN: 'vendorPn',
  ALT_NUMBER: 'altNumber',
  INTERNAL_PN: 'internalPn',
  NSNNUMBER: 'nsnNumber',
  HARMONIZED_CODE: 'harmonizedCode',
  SKU: 'sku',
  DESCRIPTION: 'description',
  MANUFACTURER_ID: 'manufacturerId',
  MFG_NAME: 'mfgName',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PIECE_PER_PKG: 'piecePerPkg',
  PHYS_PKG: 'physPkg',
  LEAD_FREE: 'leadFree',
  TEMP_RATING: 'tempRating',
  UO_MID: 'uoMId',
  UOM: 'uom',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  REVISION: 'revision',
  CONDITION_ID: 'conditionId',
  CONDITION_NAME: 'conditionName',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  POLINE_COMMENTS: 'poLineComments',
  POLINE_QUANTITY: 'poLineQuantity',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  CURRENCY_SYMBOL: 'currencySymbol',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};